module.exports = __webpack_public_path__ + "img/choose-box.503f9c36.png";